import PropTypes from 'prop-types'
import { withTimezone, momentOffset } from 'utils/time'

const DateTime = ({ date, dateOnly, timeOnly, todayTimeOnly, utcOffset }) => {
  const dateMoment = momentOffset(utcOffset, date)
  const isToday = dateMoment.isSame(momentOffset(utcOffset), 'day')

  if (isToday && todayTimeOnly) {
    return dateMoment.format('h:mma')
  }

  if (dateOnly) {
    return dateMoment.format('MMM Do')
  }

  if (timeOnly) {
    return dateMoment.format('h:mma')
  }

  return dateMoment.format('MMM Do, h:mm a')
}

DateTime.propTypes = {
  date: PropTypes.any.isRequired,
  dateOnly: PropTypes.bool,
  timeOnly: PropTypes.bool,
  todayTimeOnly: PropTypes.bool,
  utcOffset: PropTypes.number,
}

export default withTimezone(DateTime)
